import React from "react"
import { Col, Input, FormGroup } from "reactstrap"

export default function VehicleType({
  title,
  idx,
  getVehiclesForVehicleTypeDropdown,
  handleNestedChange,
  state,
}) {
  return (
    <Col lg="3">
      <FormGroup>
        <label
          className="form-control-label"
          htmlFor={"vehicleType-title-" + idx}
        >
          Title
        </label>
        <Input
          value={title || "Select Vehicle Type"}
          id={"vehicleType-title-" + idx}
          placeholder="Select Vehicle Type"
          type="select"
          // valid={this.state.validation.form['vehicleType-title-' + idx] === 'valid'}
          // invalid={this.state.validation.form['vehicleType-title-' + idx] === 'invalid'}
          onChange={(e) => handleNestedChange(e, idx, "vehicleType", "title")}
          // autoComplete="off"
        >
          <option disabled>Select Vehicle Type</option>
          {getVehiclesForVehicleTypeDropdown(title).map((v, idx) => (
            <option key={idx}>{v.title}</option>
          ))}
        </Input>
        <div className="valid-feedback">Looks Good!</div>
        <div className="invalid-feedback">
          Title Should Be At Least 3 Characters!
        </div>
      </FormGroup>
    </Col>
  )
}
